export enum DeliveryNotePlanMode {
  Grob = 'grob',
  Detail = 'detail',
}
